import NavbarElement from '../components/sidebar/navbar';
import Sidebar from '../components/sidebar/sidebar';
import classNames from 'classnames';
import DeliveriesTable from '../components/deliveries/deliveries-table';
import AddNewDeliveryComponent from '../components/deliveries/add-new-delivery';
import React, { useState } from 'react';
import ViewDeliveryComponent from '../components/deliveries/deliveries-display-modal';

function DeliveriesPage(props) {
  const [openModal, setOpenModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const [collapsed, setSidebarCollapsed] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);
  return (
    <div
      className={classNames({
        'grid bg-zinc-100 min-h-screen': true,
        'grid-cols-sidebar': !collapsed,
        'grid-cols-sidebar-collapsed': collapsed,
        'transition-[grid-template-columns] duration-300 ease-in-out': true,
      })}
    >
      <div
        style={{
          display: 'flex',
        }}
      >
        <div>
          <Sidebar
            collapsed={collapsed}
            setCollapsed={setSidebarCollapsed}
            shown={showSidebar}
          />
        </div>
        <div className="container 2xl:max-w-full" style={{ overflow: 'auto' }}>
          <div className="h-screen flex flex-col">
            <NavbarElement
              onMenuButtonClick={() => setShowSidebar((prev) => !prev)}
            />
            {props.children}
            <div className="flex-grow overflow-hidden">
              <DeliveriesTable
                setOpenEditModal={setOpenEditModal}
                openEditModal={openEditModal}
                setSelectedId={setSelectedId}
                setOpenModal={setOpenModal}
              />
            </div>
          </div>
          <AddNewDeliveryComponent
            openModal={openModal}
            setOpenModal={setOpenModal}
          />
          <ViewDeliveryComponent
            openEditModal={openEditModal}
            setOpenEditModal={setOpenEditModal}
            docId={selectedId}
          />
        </div>
      </div>
    </div>
  );
}

export default DeliveriesPage;
